export default __webpack_public_path__ + "static/media/vendor-hero-2.6e7f70ea.png";